
import './ButtonImportTemplate.css';
import useBlock from '../../../hook/block/useBlock';
import useBlockFilter from '../../../hook/block/useBlockFilter';
import asyncReader from '/src/utils/asyncReader';
import asyncWrapper from '/src/utils/asyncWrapper';
import usePanzone from '../../../hook/useCamera';
import useShiftKey from '../../../hook/useShiftKey';
// Component for importing a scenario throught a json when you click on it
// This will create a block that you can move to chooose where you want to import all the blocks in the scenario
function ButtonImportTemplate() {
    
    const { panzone } = usePanzone();

    const { addBlockTemplate } = useBlock();

    const { findMinAndMaxBlocksCoord } = useBlockFilter();

    const { changeShiftKey, shiftKey } = useShiftKey();

    const onChange = async(event) => {

        var {x, y, scale} = panzone.getTransform();

        let file = event.target.files[0];
        // Simple reader to get the files in the input
        var [template, error] = await asyncWrapper(asyncReader,file);

        if(error !== null) {
            console.log(error);
        }

        template = JSON.parse(template);
        // Need to find the max an min coord of the template to know the size of the block's we need to create
        const coords = findMinAndMaxBlocksCoord(template.blocks);
        addBlockTemplate({ coords, file }, x / scale, y / scale, coords);
    }

    const onClick = () => shiftKey ? changeShiftKey() : null;

    return (
        <div className="import" onClick={onClick}>
            <input type="file" name="file" className="import_file" data-allows-drop="true" accept=".json" onChange={onChange}/>
        </div>
    )
}

export default ButtonImportTemplate